<template>
  <div>
       <div class="d-md-flex justify-content-between mt-4 mt-md-0" v-if="bedrijf">
             <select v-if="vestigingen.length > 1" name="vestigingen" id="vestigingen"
                    class="btn btn-link order-md-2 mb-3 mb-md-0" v-model="activeVestiging">
                <option v-for="vestiging in vestigingen" :value="vestiging" :key="vestiging.type + '_' + vestiging.id">
                    {{ vestiging.title }}
                </option>
            </select>
            <span v-else class="order-md-1 mb-3 mb-md-0 text-uppercase font-weight-bold">
                {{ bedrijf.title }}
            </span>

            <select v-if="archive && years.length > 1" name="years" id="years" class="btn btn-link order-md-12 mb-3 mb-md-0" v-model="activeYear">
                <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
            </select>

            <h2 class="order-md-1 mb-0">Xylella Vragenlijsten</h2>
        </div>
      <div class="card card-toggle" v-for="vragenlijst in filteredVragenlijsten" :key="vragenlijst.id">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-8">
                        <p class="text-uppercase text-purple font-weight-bold mb-0">Xylella vragenlijst {{ vragenlijst.year }}</p>
                        <a :href="vragenlijst.url + urlSuffix" class="h2 m-0" v-if="!archive">{{ vragenlijst.title }}</a>
                        <span class="h2 m-0" v-else>{{ vragenlijst.title }}</span>
                        <p>{{ vragenlijst.tekst }}</p>

                        <!-- NVT-checkbox -->
                        <div class="custom-control custom-checkbox small">
                            <input type="checkbox" class="custom-control-input" :id="'toepassing-nee-' + vragenlijst.id"
                                   :checked="vragenlijst.antwoordset && vragenlijst.antwoordset.not_applicable"
                                   @change="notApplicableHandler($event, vragenlijst)">
                            <label class="custom-control-label grey" :for="'toepassing-nee-' + vragenlijst.id">Niet voor mij
                                van toepassing</label>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- afgeronde, archived vragenlijsten -->
                        <div class="text-right" v-if="archive">
                            <div>
                                <p class="small">Afgerond op {{ vragenlijst.completed_at }}</p>

                                <a :href="vragenlijst.url + urlSuffix + '&redo'" class="d-block text-uppercase font-weight-bold">
                                    <i class="fas fa-caret-right"></i> Opnieuw invullen
                                </a>
                                <template v-if="!vragenlijst.antwoordset.not_applicable">
                                    <div class="dropdown">
                                        <button type="button" class="btn btn-secondary dropdown-toggle" id="dropdownMenuButton">
                                            PDF’s
                                        </button>
                                        <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                                            <a :href="vragenlijst.pdf_url" target="_blank" class="dropdown-item" rel="nofollow noopener"
                                               >Download PDF</a>
                                            <a :href="vragenlijst.pdf_url_elucidation" target="_blank" class="dropdown-item" rel="nofollow noopener"
                                               >Download PDF (met toelichting)</a>
                                            <button @click="mailPdf($event, vragenlijst.antwoordset.id)" class="dropdown-item">E-mail PDF</button>
                                            <button @click="mailPdf($event, vragenlijst.antwoordset.id, true)" class="dropdown-item">E-mail PDF (met toelichting)</button>
                                        </div>
                                    </div>
                                </template>
                                <p v-else>N.V.T.</p>
                            </div>
                        </div>

                        <!-- gewone vragenlijsten -->
                        <div class="text-right" v-else>
                            <div v-if="vragenlijst.antwoordset.id">
                                <p class="small">Gestart op {{ vragenlijst.antwoordset.started_at }}</p>
                                <a :href="vragenlijst.url + urlSuffix" class="text-uppercase font-weight-bold"><i
                                        class="fas fa-caret-right"></i>
                                    <template v-if="vragenlijst.completed">Antwoorden aanpassen</template>
                                    <template v-else>Verder invullen</template>
                                </a>
                                <p class="small">{{ vragenlijst.question_count }} vragen: {{
                                    Math.round(vragenlijst.antwoordset.progress) }}% ingevuld</p>
                            </div>
                            <div v-else>
                                <a :href="vragenlijst.url + urlSuffix" class="text-uppercase font-weight-bold">
                                    <i class="fas fa-caret-right"></i> Begin met invullen
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="card card-body" v-if="!filteredVragenlijsten.length">
            <p v-if="archive">Er zijn nog geen vragenlijsten afgerond.</p>
            <p v-else>Geen vragenlijsten gevonden.</p>
        </div>
        <div class="card card-body" v-if="filteredVragenlijsten.length && archive">
            <div class="dropdown">
                <button type="button" class="btn btn-secondary dropdown-toggle" id="dropdownMenuButtonAll">
                    Download alle PDF’s van deze vestiging
                </button>
                <div aria-labelledby="dropdownMenuButtonAll" class="dropdown-menu">
                    <a :href="'/alle-pdfs' + urlSuffix + '&year=' + activeYear" target="_blank" class="dropdown-item" rel="nofollow noopener"
                    >Download PDF’s</a>
                    <a :href="'/alle-pdfs' + urlSuffix + '&year=' + activeYear + '&toelichting'" target="_blank" class="dropdown-item" rel="nofollow noopener"
                    >Download PDF’s (met toelichting)</a>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
     props: {
            archive: Boolean,
            locations: Array,
    },
    data(){
        return {
            vragenlijsten: [],
            activeVestiging: null,
            activeYear: new Date().getFullYear(),
            vestigingen: this.locations,
            bedrijf: _.find(this.locations, {type: 'main'}),
        };
    },
    created() {
        this.activeVestiging = this.vestigingen[0];
    },
    computed: {
        years() {
            return _.uniq(_.map(_.filter(this.vragenlijsten, 'completed'), 'year'));
        },
        urlSuffix() {
            return this.activeVestiging.type === 'extra' ? '?vestiging=' + this.activeVestiging.id : '?bedrijf=' + this.bedrijf.id;
        },
        filteredVragenlijsten() {
            return _.filter(this.vragenlijsten, {completed: this.archive});
        }
    },
    methods: {
        notApplicableHandler(event, vragenlijst) {
                event.currentTarget.blur();

                vragenlijst.antwoordset.not_applicable = !vragenlijst.antwoordset.not_applicable;

                this.axios.post('/xylella/antwoord-nvt/' + vragenlijst.id + (vragenlijst.antwoordset.id ? '/' + vragenlijst.antwoordset.id : ''), {
                    vestigingId: this.activeVestiging.id,
                    vestigingType: this.activeVestiging.type,
                    checked: !!event.currentTarget.checked,
                }).then(response => {
                    vragenlijst.completed = response.data.isCompleted;
                })
            },
        mailPdf(event, antwoordsetId, withElucidation) {
                event.currentTarget.blur();

                this.axios.post('xylella/mail/' + antwoordsetId + (withElucidation ? '?toelichting' : ''));

                this.$notify({
                    group: 'base',
                    text: 'U ontvangt zodadelijk een e-mail met de vragenlijst.',
                    type: 'alert-success',
                });
            },
    },
    watch: {
        activeVestiging(vestiging) {
            this.axios.get('/xylella/vragenlijsten' + (vestiging.type === 'extra' ? '/' + vestiging.id : ''))
                .then(response => {
                    this.vragenlijsten = response.data;
                    this.activeYear = new Date().getFullYear();
                })
                .catch(error => {
                    console.log(error);
            });
        }
    }

}
</script>
